// extracted by mini-css-extract-plugin
export default {"wrapper":"button-radius-50_wrapper__Uqggf"};